import type { Announcement } from '../types';

export const a_2026_07_15: Announcement = {
  id: '2026-07-15-organisation-pieces',
  date: '2026-07-15',
  layout: 'spotlight',
  kicker: 'Mise à jour produit · 15 juillet 2026',
  title: "Hector s'améliore : l'organisation des pièces, sur simple demande",
  navLabel: 'Organisation des pièces',
  subtitle: '',
  intro: [
    "Demandez à Hector d'organiser les pièces de votre dossier en langage naturel : il numérote, renomme et classe vos pièces pour vous, directement dans la conversation, sans passer par un écran dédié.",
    "Que vous passiez par l'assistant Hector dans la plateforme ou par l'agent d'édition dans Word, il vous suffit de le lui demander, quel que soit le nombre de pièces de votre dossier.",
  ],
  videoCaption: 'Découvrez-le en vidéo',
  // Embed YouTube — https://youtu.be/5nAk0wbRiNQ
  video: { provider: 'youtube', id: '5nAk0wbRiNQ' },
  sections: [
    {
      label: 'Ce que vous pouvez lui demander',
      features: [
        {
          id: 'numeroter-pieces',
          title: 'Numéroter vos pièces',
          body: {
            kind: 'paragraphs',
            paragraphs: [
              "« Numérote les pièces du dossier » : Hector attribue les numéros dans l'ordre, sur l'ensemble du dossier.",
            ],
          },
        },
        {
          id: 'renommer-pieces',
          title: 'Renommer vos pièces',
          body: {
            kind: 'paragraphs',
            paragraphs: [
              "« Renomme la pièce 3 » ou « retire les dates des intitulés » : Hector met à jour les noms de vos pièces selon vos consignes.",
            ],
          },
        },
        {
          id: 'classer-sous-dossiers',
          title: 'Les classer en sous-dossiers',
          body: {
            kind: 'paragraphs',
            paragraphs: [
              "« Range les pièces adverses dans un sous-dossier » : Hector crée les sous-dossiers utiles et y déplace les pièces. Il peut aussi les ramener à la racine ou renommer un sous-dossier existant.",
            ],
          },
        },
      ],
    },
  ],
};
